import React from "react";
import Product from "./ProductComponent";
import { IProduct } from "../types/Product"
import ProductSkeleton from "./ProductComponentSkeleton";

interface Product {
    id: string;
    title: string;
    image: string;
    price: number;
}

const ProductGroup: React.FC<{ products: IProduct[] }> = ({ products }) => {
    return (
        <div className="product-container" key={products.length}>
            <div className="product-slider columns">
                {products.map((product, index) => (
                    product == null ? <ProductSkeleton></ProductSkeleton> : <Product product={product} />
                ))}
            </div>
        </div>
    );
};

export default ProductGroup;